<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :modal="false"
    custom-class="custom-dialog"
    top="60px"
    width="800px"
  >
    <div slot="title" class="title">
      <div class="title-name">{{ title || '预览' }}</div>
      <div class="side-title"></div>
    </div>
    <div v-if="dialogVisible" class="dialog-content">
      <div v-if="type == 'word'" style="height:100%;position:relative">
        <div id="testIframePeixun" style="height:100%"></div>
      </div>
      <div v-else-if="type == 'img'" style="height:100%;overflow:auto"><img :src="url" style="width:100%" /></div>
      <iframe
        v-else-if="url"
        id="iframe"
        :src="url + '#toolbar=0'"
        width="100%"
        height="100%"
        frameborder="no"
        border="0"
        marginwidth="0"
        marginheight="0"
        scrolling="auto"
        allowtransparency="yes"
      />
    </div>
  </el-dialog>
</template>
<script>
// import WPSOfficeSDK from '../../../assets/weboffice/web-office-sdk-v1.1.2.es'
export default {
  data() {
    return {
      dialogVisible: false,
      url: '',
      type: '',
      title: '',
      config: {
        document: {
          fileType: 'docx',
          key: '',
          title: '',
          permissions: {
            chat: false,
            comment: false,
            copy: false,
            download: false,
            edit: false,
            fillForms: false,
            modifyContentControl: false,
            modifyFilter: false,
            print: false,
            review: false,
            reviewGroups: null,
            commentGroups: {},
            userInfoGroups: null,
          },
          // url: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/test1.html',
          url:
            'https://alphahr.oss-cn-beijing.aliyuncs.com/public/d32bfbcd863860b41535f5fc1923396d.%E6%98%93%E7%A5%96%E6%B1%9F-%E7%A8%8E%E5%8A%A1%E8%B4%9F%E8%B4%A3%E4%BA%BA-%E4%B8%AD%E5%A4%96%E5%90%88%E8%90%A5%EF%BC%88%E5%90%88%E8%B5%84%C2%B7%E5%90%88%E4%BD%9C%EF%BC%89-%E7%94%B7-32%E5%B2%81-%E7%A1%95%E5%A3%AB-8%E5%B9%B4%E4%BB%A5%E4%B8%8A%E5%B7%A5%E4%BD%9C%E7%BB%8F%E9%AA%8C%E7%8C%8E%E8%81%98%E7%AE%80%E5%8E%86.docx',
        },
        documentType: 'word',
        editorConfig: {
          actionLink: null,
          callbackUrl: 'http://47.93.158.22:11000/example/track?filename=new.docx&useraddress=27.47.132.115',
          coEditing: null,
          createUrl: null,
          customization: {
            about: false,
            comments: false,
            feedback: false,
            forcesave: false,
            submitForm: false,
            compactHeader: true,
            compactToolbar: true,
            hideRightMenu: true,
            hideRulers: true,
            toolbarNoTabs: true,
            // zoom: -1,
            features: {
              spellcheck: false,
            },
            integrationMode: 'embed',
            logo: {
              image: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/assets/alpha-logo.png',
            },
          },
          user: {
            group: '',
            id: app.user._id,
            name: app.user.account || 'test',
          },
          region: 'zh-CN',
          lang: 'zh-CN',
          plugins: false,
        },
        mode: 'view',
        height: '100%',
        width: '100%',
        type: 'desktop',
      },
      originalname: '',
      documentType: 'word',
      fileType: 'docx',
      md5: '',
      docEditor: null,
    }
  },
  computed: {
    isOfficeUrl() {
      const wordTypeReg = /(\.doc)|(\.docm)|(\.docx)|(\.docxf)|(\.dot)|(\.dotm)|(\.dotx)|(\.epub)|(\.fodt)|(\.fb2)|(\.htm)|(\.html)|(\.mht)|(\.odt)|(\.oform)|(\.ott)|(\.oxps)|(\.pdf)|(\.rtf)|(\.txt)|(\.djvu)|(\.xml)|(\.xps)/
      const excelTypeReg = /(\.csv)|(\.fods)|(\.ods)|(\.ots)|(\.xls)|(\.xlsb)|(\.xlsm)|(\.xlsx)|(\.xlt)|(\.xltm)|(\.xltx)/
      const pptTypeReg = /(.fodp)|(\.odp)|(\.otp)|(\.pot)|(\.potm)|(\.potx)|(\.pps)|(\.ppsm)|(\.ppsx)|(\.ppt)|(\.pptm)|(\.pptx)/
      return wordTypeReg.test(this.url) || excelTypeReg.test(this.url) || pptTypeReg.test(this.url)
    },
    isAdmin() {
      return app.user.角色 && app.user.角色.includes('管理员')
    },
    isShuju() {
      return app.user.角色 && app.user.角色.includes('数据处理')
    },
  },
  async mounted() {
    this.user = app.user.account
    this.config.events = {
      onError: this.destoryEditor(),
      onRequestClose: this.destoryEditor(),
    }
  },
  methods: {
    async open(item) {
      if (!item.url && !item.md5) return this.$message.error('没有附件地址')
      this.url = item.url
      this.type = item.type
      this.title = item.title
      this.dialogVisible = true
      if (this.type == 'word') {
        if (!item.md5) {
          return this.$message.error('没有md5')
        }
        const src = await window.app.service('file').buildPreview({ md5: item.md5 })
        const url = src.url
        if (window.location.origin.indexOf('https://') !== -1) {
          this.url = url.replace('http://', 'https://')
        } else if (window.location.origin.indexOf('http://') !== -1) {
          this.url = url.replace('https://', 'http://')
        }
        this.documentType = src.documentType
        this.originalname = src.originalname
        this.fileType = src.fileType
        this.md5 = src.md5
        if (this.isOfficeUrl) {
          this.config.documentType = this.documentType
          this.config.document.fileType = this.fileType
          this.config.document.key = this.md5
          this.config.document.title = this.originalname
          this.config.document.url = this.url
          this.config.events = {
            onError: this.destoryEditor(),
            onRequestClose: this.destoryEditor(),
          }
          if (this.isShuju || this.isAdmin) {
            this.config.document.permissions.copy = true
          }
        }
        this.$nextTick(() => {
          if (!this.docEditor && this.isOfficeUrl) {
            this.docEditor = new window.DocsAPI.DocEditor('testIframePeixun', this.config)
          }
        })
      }
    },
    onCancel() {
      this.destoryEditor()
      this.dialogVisible = false
    },
    destoryEditor() {
      this.docEditor && this.docEditor.destroyEditor()
      this.docEditor = null
    },
  },
}
</script>
<style scoped>
.dialog-content {
  height: 600px;
}
</style>
